import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoiceMid: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVoiceMid"><Path d="M8.5 19H7V5H8.5V19Z" fill="currentColor"/><Path d="M17 17H15.5V7H17V17Z" fill="currentColor"/><Path d="M12.75 15H11.25V9H12.75V15Z" fill="currentColor"/><Path d="M4.5 14H3V10H4.5V14Z" fill="currentColor"/><Path d="M21 14H19.5V10H21V14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVoiceMid;
